export const task1 = {
  title: '1st Case: Troll Hunter',
  bubble: 'Your friend Sam has sent you a video',
  message:
    'You need to make a decision of what to do with this information. Make sure you choose the right one!'
};

export const task2 = {
  title: '2nd Case: Thief Buster',
  bubble: 'Decide whether the following is real',
  message:
    'Your mission is to choose whether or not the following letter is real- or from someone trying to steal your details.'
};

export const task3 = {
  title: '3rd Case: Password Time Challenge',
  bubble: 'Your device has been hacked!',
  message:
    'You have only 30 seconds to change the password and make it more secure!'
};
